<template>
  <v-row class="ma-5">
    <h3 class="ml-2 text-start" style="width: 100%">
      Selecione o tipo de agente que deseja exercer.
    </h3>
    <v-col class="justify-center" v-for="item in items" :key="item.tipoSolicitacao" cols="12" sm="6" md="6" lg="3">
      <div
        :class="[
          'app-list-services__link',
          'agent-card',
          { selected: selected === item.tipoSolicitacao },
        ]"
        @click="select(item.tipoSolicitacao)"
        style="cursor: pointer; max-width: 350px; height: 178px"
      >
        <div
          :class="[
            item.tipoSolicitacao === 'CONSUMIDOR_CATIVO_LIVRE'
              ? 'area-icon-free-consumer'
              : 'area-icon',
            '',
            'mb-2',
          ]"
        >
          <template v-if="item.tipoSolicitacao === 'CONSUMIDOR_CATIVO_LIVRE'">
            <div class="icon-arrow-group">
              <v-icon class="icon" size="18">home</v-icon>
              <v-icon class="arrow-icon" size="16">arrow_forward</v-icon>
              <v-icon class="icon" size="18">verified_user</v-icon>
            </div>
          </template>
          <template v-else-if="Array.isArray(tipoSolicitacaoIcons[item.tipoSolicitacao])">
            <v-icon
              v-for="icon in tipoSolicitacaoIcons[item.tipoSolicitacao]"
              :key="icon"
              class="icon"
              size="25"
              >{{ icon }}</v-icon
            >
          </template>
          <template v-else>
            <v-icon class="icon" size="25">{{ tipoSolicitacaoIcons[item.tipoSolicitacao] }}</v-icon>
          </template>
        </div>
        <span class="title agent-title">
          {{ formatarTipoSolicitacao(item) }}
        </span>
        <p class="mt-3 subtitle" style="font-size: 11px">
          {{ tipoSolicitacao[item.tipoSolicitacao] }}
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CardTipoAgentes',
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selected: this.value,
      tipoSolicitacao: {
        COMERCIALIZADOR:
          'Desejo me registar como Comercializador, fornecendo gás canalizado ao mercado livre de gás do Estado do Ceará.',
        AUTOPRODUTOR: 'Desejo me registrar como Autoprodutor, produzindo o gás que irei consumir.',
        AUTOIMPORTADOR:
          'Desejo me registrar como Autoimportador, importando o gás que irei consumir.',
        CONSUMIDOR_CATIVO:
          'Tenho contrato vigente com uma concessionária de gás canalizado, mas quero me tornar um Consumidor Livre, para comprar de outros fornecedores.',
        CONSUMIDOR_CATIVO_LIVRE:
          'Já tenho a pré-autorização e desejo concluir o processo para me tornar um Consumidor Livre.',
        CONSUMIDOR_LIVRE: 'Quero me registrar como Consumidor Livre de gás canalizado.',
      },
      tipoSolicitacaoIcons: {
        COMERCIALIZADOR: 'storefront',
        AUTOPRODUTOR: 'factory',
        AUTOIMPORTADOR: 'local_shipping',
        CONSUMIDOR_CATIVO: 'home',
        CONSUMIDOR_LIVRE: 'verified_user',
        CONSUMIDOR_CATIVO_LIVRE: ['home', 'verified_user'], // Mantém para compatibilidade
      },
    };
  },
  watch: {
    value(val) {
      this.selected = val;
    },
  },
  methods: {
    select(tipo) {
      this.selected = tipo;
      this.$emit('input', tipo);
      this.$emit('change', tipo);
    },
    formatarTipoSolicitacao(item) {
      if (!item || !item.tipoSolicitacao) return '';
      return item.tipoSolicitacao
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(^|\s)\S/g, l => l.toUpperCase());
    },
  },
};
</script>

<style lang="scss" scoped>
.app-list-services__link.agent-card {
  background-color: #fff;
  display: flex;
  border-radius: 10px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.08);
  min-height: 125px;
  width: 100%;
  align-items: center;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  padding: 10px 20px;
  border: 2px solid transparent;
  transition: background 0.1s, border-color 0.2s, box-shadow 0.2s;
}
.app-list-services__link.agent-card.selected {
  border-color: #1976d2;
  box-shadow: 0 4px 18px 0 rgba(25, 118, 210, 0.12);
}
.app-list-services__link.agent-card:hover {
  background-color: #1976d2;
  .title {
    color: #fff;
  }
  .subtitle {
    color: #fff;
  }
}
.area-icon {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  justify-content: center;
}
.area-icon-free-consumer {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 50px;
  width: 90px;
  height: 50px;
  justify-content: center;
}
.icon-arrow-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 100%;
}
.arrow-icon {
  color: #1976d2;
  margin: 0 2px;
}
.icon {
  color: #1976d2;
  font-size: 25px;
  margin: auto;
}
.title.agent-title {
  color: #58595b;
  line-height: 15px;
  font-size: 15px !important;
  margin-top: 5px;
  font-weight: 500;
  text-align: center;
  width: 100%;
}
h3 {
  color: #58595b !important;
}
</style>
